import { configureStore } from "@reduxjs/toolkit";
import clientReducer from "./Slices/SelectedClientSlice";
import userInformationReducer from "./Slices/UserInformationSlice";
import billingTiersReducer from "./Slices/BillingTiersSlice";

const store = configureStore({
  reducer: {
    selectedClient: clientReducer,
    userInformation: userInformationReducer,
    billingTiers: billingTiersReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;

export default store;
